import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../api/client";
import type { CreateTokenInput, CreatedTokenResult, TokenRow } from "./types";

export const TOKENS_KEY = (workspaceId?: string | null) =>
  ["tokens", workspaceId ?? "all"] as const;

export function useTokensList(workspaceId?: string | null) {
  const qs = workspaceId ? `?workspaceId=${encodeURIComponent(workspaceId)}` : "";
  return useQuery({
    queryKey: TOKENS_KEY(workspaceId),
    // GET /api/me/tokens returns a bare array (not { tokens: [...] }).
    queryFn: () => apiFetch<TokenRow[]>(`/api/me/tokens${qs}`),
    staleTime: 30_000,
  });
}

export function useCreateToken(workspaceId?: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTokenInput) =>
      apiFetch<CreatedTokenResult>("/api/me/tokens", {
        method: "POST",
        body: input,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: TOKENS_KEY(workspaceId) }),
  });
}

export function useRevokeToken(workspaceId?: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) =>
      apiFetch<{ ok: true }>(`/api/me/tokens/${encodeURIComponent(id)}/revoke`, {
        method: "POST",
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: TOKENS_KEY(workspaceId) }),
  });
}
